import cloneDeep from 'lodash.clonedeep';

const XAxisConfigPropertyKey = {
  Categories: 'categories',
  Tooltip: 'tooltip',
};

const DEFAULT_X_AXIS_CONFIG = {
  [XAxisConfigPropertyKey.Categories]: [],
  [XAxisConfigPropertyKey.Tooltip]: {
    enabled: false,
  },
};

export default class XAxisConfigBuilder {
  #config = cloneDeep(DEFAULT_X_AXIS_CONFIG);

  setCategories(categories) {
    return this.#setProperty(XAxisConfigPropertyKey.Categories, categories);
  }

  build() {
    return this.#config;
  }

  #setProperty(propertyName, value) {
    this.#config[propertyName] = value;

    return this;
  }
}
